import React, { useState } from "react";
import postConfig from "../constants/postConfig.js";
import VideoGallery from '../components/InsightTestimonials.js';
import NewsEvents from '../components/InsightNewsEvents.js';
import Articles from '../components/InsightArticles.js';
import "../styles/navbar.css";
// import { HiArrowLongRight } from "react-icons/hi2";
import { MdArrowForwardIos } from "react-icons/md";
import ArrowIcon from '../components/img/right-arrow.png';
const PostSection = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [posts, setPosts] = useState(postConfig);
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <section className="post-section">
      <div className="post-container">
        <div className="post-heading">
          <section className="post-title">
            <div className="d-none d-md-block"> {/* Only visible in desktop */}
              <p className="posts">Caritas Insights</p>
              <p className="post-subtitle">
                Discover What's Happening at <br />
                Caritas
              </p>
            </div>
            <div className="d-md-none mb-2">{/* Only visible in mobile */}
              <p className="posts">Caritas Insights</p>
              <p className="post-subtitle">
                Discover What's Happening at Caritas
              </p>
            </div>
          </section>
          <div className="post-buttons">
            {posts.map((post, index) => (
              <button
                key={index}
                className={index == activeTab ? "active" : ""}
                onClick={() => handleTabChange(index)}
              >
                {post.title}
              </button>
            ))}
            {/* <button onClick={() => handleTabChange("articles")}>
                Articles
              </button>
              <button onClick={() => handleTabChange("videos")}>Videos</button> */}
          </div>
        </div>
        {/* {(activeTab == 0 || activeTab == 1) && ( */}
          <div className={`post-list ${activeTab == 0 && "active"}`}>
            {/* {posts[activeTab].data.map((post) => (
              <div key={post.id} className="post-row">
                <span className="post-titles">{post.title}</span>
                <img className="post-arow" src={ArrowIcon} alt="Arrow Icon" />
                
              </div>
            ))} */}
            <NewsEvents />
            <a href="/news-and-events">
              View All {posts[activeTab].title} <MdArrowForwardIos />
            </a>
          </div>
          <div className={`post-list ${activeTab == 1 && "active"}`}>
            {/* {posts[activeTab].data.map((post) => (
              <div key={post.id} className="post-row">
                <span className="post-titles">{post.title}</span>
                <img className="post-arow" src={ArrowIcon} alt="Arrow Icon" />
              </div>
            ))} */}

            <Articles />

            <a href="/articles">
              View All {posts[activeTab].title} <MdArrowForwardIos />
            </a>
          </div>

        {/* )} */}
        {activeTab == 2 && ( 
          <div className={`post-vid-list ${activeTab == 2 && "active"}`}>
            <VideoGallery />
            <a className="testimonial-view-all" href="/testimonials">
              View All <MdArrowForwardIos />
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default PostSection;